import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Badge, { badgeClasses } from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';

function MenuButton({ showBadge = false, ...props }) {
  return (
    <Badge
      color="error"
      variant="dot"
      invisible={!showBadge}
      sx={{ [`& .${badgeClasses.badge}`]: { right: 2, top: 2 } }}
    >
      <IconButton
        size="small"
        sx={(theme) => ({
          border: '1px solid',
          borderColor: alpha(theme.palette.divider, 0.95),
          backgroundColor: alpha(theme.palette.background.paper, 0.42),
          backdropFilter: 'blur(10px)',
          boxShadow: `0 10px 24px ${alpha(theme.palette.common.black, 0.08)}`,
          '&:hover': {
            backgroundColor: alpha(theme.palette.background.paper, 0.62),
          },
        })}
        {...props}
      />
    </Badge>
  );
}

MenuButton.propTypes = {
  showBadge: PropTypes.bool,
};

export default MenuButton;
